import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arr-right-icon_blue",
  "use": "arr-right-icon_blue-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"arr-right-icon_blue\">\n    <path fill=\"#003595\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.84068 0L6.19578 0.625003L10.2542 4.55808H0V5.44196H10.2542L6.19584 9.375L6.84074 10L11.3551 5.62502L12 5.00001L11.3552 4.37498L6.84068 0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol